import React from 'react';
import { UnderwritingContext, UnderwritingContextType } from 'src/providers';

export const useUnderwritingContext = (): UnderwritingContextType => {
  return React.useContext<UnderwritingContextType>(UnderwritingContext);
};
